import styled from 'styled-components';

import { PrimaryButton } from 'components/v2/Button';

/**
 * Equal-column grid that lays out the selectors on a single row.
 * Column count is driven by the `$columns` prop.
 */
export const SelectorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: ${({ theme }) => theme.spacing.s2};
  width: 100%;
`;

/**
 * A `PrimaryButton` tuned for selector usage: stretches to its grid column,
 * uses 16px padding, and left-aligns its label. All color, hover, and active
 * behavior is inherited from `PrimaryButton` so the selected/unselected states
 * match the shared button library.
 */
export const StyledSelector = styled(PrimaryButton)`
  &&.MuiButton-root {
    width: 100%;
    min-width: 0;
    padding: ${({ theme }) => theme.spacing.s4};
    justify-content: flex-start;
    text-align: left;
  }
`;
